import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { validateField } from "../../contexts/Utils";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  addBOMPart,
  getPartListByCompanyFilter,
  getPartDataListByCompFilter,
  GetPartById,
  getBOMsbyPart,
} from "../../api";
import { Header, Button } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddPart.css";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import TextInputField from "../../components/TextInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import AsyncSelectField from "../../components/AsyncSelectField";
import DoubleField from "../../components/DoubleField";

const AddEditBOM = () => {
  const navigate = useNavigate();
  let param = useParams();
  const Part_id = param.bom_id || 0;
  const [partOptions, setPartOptions] = useState([]);
  const [altPartOptions, setAltPartOptions] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [Part, setPart] = useState("");
  const [companyId, setCompanyId] = useState(0);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);
  const [loadBtn, setLoadBtn] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    child_part: "select",
    quantity: "1",
    ref_desc: "",
    alternate_part: "select",
    dni: false,
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  const handleDeleteClick = (index) => {
    TimeoutUtility.resetTimeout();
    const remProd = itemList[index];
    if (
      window.confirm(`Do you want to remove ${remProd.part_number} from BOM?`)
    ) {
      const newCartList = [...itemList];
      newCartList.splice(index, 1);
      setItemList(newCartList);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleChangeDNI = () => {
    const serr = formData.dni;
    setFormData((prev) => ({ ...prev, dni: serr ? false : true }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const loadOptions = async (inputText, callback) => {
    if (inputText.length > 2) {
      await getPartDataListByCompFilter(companyId, inputText)
        .then((resp) => {
          const partOptions1 = resp.data.map((item) => ({
            label: `${item.part_number} - ${item.description}`,
            value: item.part_id,
            part_number: item.part_number,
            description: item.description,
            category: item.category,
            unit: item.unit,
            bom_str: item.bom_str,
          }));
          setPartOptions(partOptions1 || []);
          callback(partOptions1 || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(partOptions);
  };

  const loadAltOptions = async (inputText, callback) => {
    if (inputText.length > 2) {
      await getPartListByCompanyFilter(companyId, inputText)
        .then((resp) => {
          const partOptions1 = resp.data.map((item) => ({
            label: `${item.part_number} - ${item.description}`,
            value: item.part_id,
          }));
          setAltPartOptions(partOptions1 || []);
          callback(partOptions1 || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(altPartOptions);
  };

  const handleAddItemClick = () => {
    try {
      const newErrors = {};
      Object.keys(formData).forEach((key) => {
        const error = validateField(key, formData[key], key);
        if (error) newErrors[key] = error;
      });
      if (!newErrors["child_part"]) {
        if (
          itemList.some(
            (item) =>
              item.part_id === formData.child_part.value ||
              item.alt_part_id === formData.child_part.value,
          )
        )
          newErrors["child_part"] = "This Child Part is already in the BOM!";
        if (parseInt(Part_id) === parseInt(formData.child_part.value))
          newErrors["child_part"] = "Child Part cannot be same as Parent Part!";
      }
      setErrors(newErrors);
      if (Object.keys(newErrors).length > 0) {
        return;
      }

      let alt_id = null,
        alt_desc = "";
      if (formData.alternate_part !== "select") {
        alt_id = formData.alternate_part.value;
        alt_desc = formData.alternate_part.label;
      }
      const updatedItem = [...itemList];
      const defaultPart = {
        part_id: formData.child_part.value,
        part_number: formData.child_part.part_number,
        description: formData.child_part.description,
        category: formData.child_part.category,
        unit: formData.child_part.unit,
        bom: formData.child_part.bom_str,
        quantity: formData.quantity,
        ref_desc: formData.ref_desc,
        alt_part_id: alt_id,
        alt_part_desc: alt_desc,
        dni: formData.dni,
      };
      setFormData({
        child_part: "select",
        quantity: "1",
        ref_desc: "",
        alternate_part: "select",
        dni: false,
      });
      setItemList([defaultPart, ...updatedItem]);
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdateBOMClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    let childParts = [];
    itemList.forEach((part) => {
      const childPart = {
        child_part_id: part.part_id,
        quantity: part.quantity,
        ref_des: part.ref_desc || "",
        alternate_part_id: part.alt_part_id,
        dni: part.dni,
      };
      childParts.push(childPart);
    });
    try {
      const response = await addBOMPart(Part_id, childParts);
      if (response.success) {
        showSuccessToast("Success!", "BOM updated successfully.");
        navigate("/Part");
      } else
        showErrorToast(
          "Error!",
          "BOM failed to update!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "BOM failed to update!");
    } finally {
      setLoadBtn(false);
    }
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  useEffect(() => {
    async function fetchData() {
      if (Part_id) {
        setloading(true);
        trackPromise(
          Promise.all([GetPartById(Part_id), getBOMsbyPart(Part_id)])
            .then(([res1, result2]) => {
              setPart(`${res1.data.part_number} - ${res1.data.description}`);
              setCompanyId(res1.data.company_id);
              if (result2.data && result2.data.length > 0) {
                const productList = result2.data.map((item) => ({
                  part_id: item.part_id,
                  part_number: item.part_number,
                  description: item.description,
                  category: item.category,
                  unit: item.unit,
                  bom: item.bom_str,
                  quantity: item.quantity,
                  ref_desc: item.ref_des || "",
                  alt_part_id: item.alternate_part_id,
                  alt_part_desc: `${item.alternate_part_number} - ${item.alternate_part_description}`,
                  dni: item.dni,
                }));
                setItemList(() => [...productList]);
              }
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [Part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="UPDATE BOM" />
      <Container className="g-0 form-container" fluid="true">
        <Row xs={1} sm={1} style={{ justifyContent: "center" }}>
          <Col md={8} className="container-col">
            {loading && promiseInProgress ? (
              <LoadingIndicator />
            ) : (
              <TextInputField
                label="Part Number & Description:"
                name="location"
                value={Part}
                placeholder="Part Number & Description:"
                disabled
              />
            )}
          </Col>
          <Col md={12} className="container-col pt-8 ml-12">
            <label className="label" style={{ fontSize: "24px" }}>
              BOM ITEMS:
            </label>
          </Col>
          <Row className="pl-2 pr-2 pb-4 justify-content-center">
            <Col md={3} sm={6} className="container-col">
              <AsyncSelectField
                label="Child Part:"
                name="child_part"
                value={formData.child_part}
                loadOptions={loadOptions}
                // options={partOptions}
                onChange={handleSelectChange}
                placeholder="Child Part"
                compulsory={true}
                error={errors.child_part}
                autoFocus
              />
            </Col>
            <Col md={2} sm={4} className="container-col">
              <DoubleField
                label="Quantity:"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                placeholder="Quantity"
                min="0"
                step="1.00"
                compulsory={true}
                error={errors.quantity}
              />
            </Col>
            <Col md={2} sm={4} className="container-col">
              <TextInputField
                label="Ref Description:"
                name="ref_desc"
                value={formData.ref_desc}
                onChange={handleChange}
                placeholder="Ref Desc"
                error={errors.ref_desc}
              />
            </Col>
            <Col md={3} sm={6} className="container-col">
              <AsyncSelectField
                label="Alternate Part:"
                name="alternate_part"
                value={formData.alternate_part}
                loadOptions={loadAltOptions}
                onChange={handleSelectChange}
                placeholder="Alternate Part"
                error={errors.alternate_part}
              />
            </Col>
            <Col md={1} sm={1} className="container-col">
              <div className="form-group mt-3">
                <label className="label">DNI:</label>
                <input
                  type="checkbox"
                  className="input"
                  name="dni"
                  checked={formData.dni}
                  onChange={handleChangeDNI}
                />
              </div>
            </Col>
            <Col md={1} className="container-col pt-7">
              <Button
                text="Add"
                onClick={handleAddItemClick}
                disabled={loadBtn}
              />
            </Col>
          </Row>
          <Col md={12}>
            <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
              <div
                className="m-0 p-0 table-container-sale"
                style={{ height: "48vh" }}
              >
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="table-sale-tr">
                      <th style={{ width: "260px" }}>PART DESCRIPTION</th>
                      <th style={{ width: "70px" }}>CATEGORY</th>
                      <th style={{ width: "50px" }}>UNIT</th>
                      <th style={{ width: "40px" }}>QTY</th>
                      <th style={{ width: "120px" }}>REF DESC</th>
                      <th style={{ width: "120px" }}>ALTERNATE</th>
                      <th style={{ width: "35px" }}>DNI</th>
                      <th style={{ width: "35px" }}>BOM</th>
                      <th style={{ width: "35px" }}>DEL</th>
                    </tr>
                  </thead>
                  <tbody className="pos-table-body">
                    {itemList?.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <div style={{ display: "flex", flexWrap: "wrap" }}>
                            <div
                              style={{
                                flex: "0 0 100%",
                                paddingTop: "8px",
                                paddingBottom: "7px",
                                alignSelf: "center",
                              }}
                            >
                              <div style={{ fontWeight: "bold" }}>
                                {item.part_number}
                              </div>
                              <div>{truncate(item.description, 90)}</div>
                            </div>
                          </div>
                        </td>
                        <td>{item.category}</td>
                        <td>{item.unit}</td>
                        <td>{item.quantity}</td>
                        <td>{item.ref_desc}</td>
                        <td>{truncate(item.alt_part_desc, 64)}</td>
                        <td>{item.dni ? "True" : "False"}</td>
                        <td>
                          {item.bom === "True" ? (
                            <Link
                              to={`/BOMs/AddEditBOM/${item.part_id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Edit
                            </Link>
                          ) : (
                            `-`
                          )}
                        </td>
                        <td>
                          <button onClick={() => handleDeleteClick(index)}>
                            ❌
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleUpdateBOMClick}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddEditBOM;
